const UNIT_TO_BASE: Record<string, 'g' | 'ml' | 'stk'> = {
  g: 'g',
  kg: 'g',
  ml: 'ml',
  l: 'ml',
  stk: 'stk',
  stück: 'stk',
  pieces: 'stk',
  piece: 'stk',
}

export type ParsedQuantity = { amount: number; unit: 'g' | 'ml' | 'stk' }

export function parseQuantityMass(quantityMass: string): ParsedQuantity {
  const parts = quantityMass.split('+').map((p) => p.trim())
  let totalG = 0
  let totalMl = 0
  let totalStk = 0

  for (const part of parts) {
    const match = part.match(/([\d.,]+)\s*(kg|g|l|ml|stk|stück|pieces?)?/i)
    if (!match) continue
    const value = parseFloat(match[1].replace(',', '.'))
    const rawUnit = (match[2] ?? 'stk').toLowerCase()
    const unit = UNIT_TO_BASE[rawUnit] ?? 'stk'
    if (unit === 'g') totalG += rawUnit === 'kg' ? value * 1000 : value
    else if (unit === 'ml') totalMl += rawUnit === 'l' ? value * 1000 : value
    else totalStk += value
  }

  if (totalG > 0) return { amount: totalG, unit: 'g' }
  if (totalMl > 0) return { amount: totalMl, unit: 'ml' }
  return { amount: totalStk || 1, unit: 'stk' }
}

export function formatQuantity({ amount, unit }: ParsedQuantity): string {
  if (unit === 'g') {
    if (amount >= 1000) return `${Math.round((amount / 1000) * 10) / 10}kg`
    return `${Math.round(amount)}g`
  }
  if (unit === 'ml') {
    if (amount >= 1000) return `${Math.round((amount / 1000) * 10) / 10}l`
    return `${Math.round(amount)}ml`
  }
  const rounded = Math.round(amount * 10) / 10
  return `${rounded} ${rounded === 1 ? 'piece' : 'pieces'}`
}

export function mergeQuantityMass(a: string, b: string): string {
  const left = parseQuantityMass(a)
  const right = parseQuantityMass(b)
  if (left.unit === right.unit) {
    return formatQuantity({ amount: left.amount + right.amount, unit: left.unit })
  }
  const parts = [a.trim(), b.trim()].filter(Boolean)
  return parts.join(' + ')
}
